import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ViewUserData } from 'src/app/2.view/view.user.data/view.user.data';

const routes: Routes = [
    { path: '', component: ViewUserData },
    { path: '**', component: ViewUserData }
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule]
})
export class AppModuleRouting { }